<template>
    <div>
        <div class="container">
            <div class="row">
                <div class="col-sm-12">
                    <h1>{{ $t('order_status.title') }}</h1>
                    <p>{{ $t('order_status.description') }}</p>

                    <!--
                    <img src="https://cdn.dribbble.com/users/267/screenshots/1927432/loading.gif" v-show="active_order.status == ''">{{ active_order.status }}</img>
                    -->
                    <p v-show="active_order.status != ''">{{ active_order.status }}</p>
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
    body {
        font-family: "Roboto", sans-serif;
    }
</style>
<script>
  import {mapActions, mapGetters} from 'vuex';

  export default {
    computed: {
      ...mapGetters([
        'active_order',
      ]),
      module_id () {
        return this.$route.params.module_id;
      },
      order_id () {
        return this.$route.params.order_id;
      },
      unique_id () {
        return this.$route.params.unique_id;
      },
    },

    methods: {
      ...mapActions([
        'get_order_status',
      ])
    },

    mounted () {
      this.get_order_status({
        module_id: this.module_id,
        order_id: this.order_id,
        unique_id: this.unique_id
      });
    },

    updated () {
      if (this.active_order.status === 'PAID' || this.active_order.status === 'PARTIAL_PAYMENT') {
        let hostname = window.location.hostname;
        if (hostname === 'localhost') {
          hostname = 'localhost:8080';
        }
        window.top.location.href = window.location.protocol + '//' + hostname + '/#/' + 'result' + '/' + this.module_id + '/' + this.order_id;
      } else {
        setTimeout(() => {
          this.get_order_status({
            module_id: this.module_id,
            order_id: this.order_id,
            unique_id: this.unique_id
          });
        }, 5000);
      }
    },
  };
</script>



// WEBPACK FOOTER //
// OrderStatus.vue?6f3a6c04